import { axios,axios2 } from '@/lib/axios';

export const changeFav = (id: string, acceptFlag: boolean) => {
  const payload = {
    sale_id: id,
    status_action: acceptFlag ? 1 : 0,
  };
  return axios2.post('/panel-api/favourite-unfavourite-sale-property', payload);
};
